/**
 * Nonces index a bitmap onchain (word = nonce >> 8, bit = nonce & 0xff): the first nonce of a word pays a
 * fresh storage slot, the next 255 are ~17k gas cheaper. So each page load draws a random 248-bit word and
 * walks its bits; another tab or device draws another word, so they never collide.
 */
let nonceWord = 0n;
let nonceBit = 256;

export function newNonce(): bigint {
  if (nonceBit > 255) {
    const b = crypto.getRandomValues(new Uint8Array(31));
    nonceWord = b.reduce((acc, x) => (acc << 8n) | BigInt(x), 0n);
    nonceBit = 0;
  }
  return (nonceWord << 8n) | BigInt(nonceBit++);
}
